import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import { Navigate } from 'react-router-dom';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const SalesChannels = Loadable(lazy(() => import('../pages/integrations/SalesChannel/SalesChannels')));
const FullfilledPartners = Loadable(lazy(() => import('../pages/integrations/fullfilled-partners')));
const ChannelListings = Loadable(lazy(() => import('../pages/listing')));
const SourceData = Loadable(lazy(() => import('../pages/inventory/index')));
const ProductCatalog = Loadable(lazy(() => import('../pages/product-catalog')));
const Orders = Loadable(lazy(() => import('../pages/component-overview/orders/orders')));
const PricingRules = Loadable(lazy(() => import('../pages/component-overview/pricing/pricingRules')));
const UserAndRoles = Loadable(lazy(() => import('../pages/users-management')));
const AuditLogs = Loadable(lazy(() => import('../pages/component-overview/audit-logs/audit-logs')));
const Competitors = Loadable(lazy(() => import('../pages/component-overview/competitors/competitors')));
const Settings = Loadable(lazy(() => import('../pages/component-overview/settings')));
const Profile = Loadable(lazy(() => import('../pages/component-overview/profile')));
const OrderDetails = Loadable(lazy(() => import('../pages/component-overview/orders/sections/OrderDetails')));
const InventoryDetail = Loadable(lazy(() => import('../pages/inventory/sections/InventoryDetail')));
const ProductCatalogDetail = Loadable(lazy(() => import('../pages/product-catalog/sections/ProductDetail')));
const ListingDetail = Loadable(lazy(() => import('../pages/listing/sections/ProductDetail')));

// ==============================|| MAIN ROUTING ||============================== //
const AuthGuard = () => {
  // Example auth check (replace with real logic)
  const isAuthenticated = !!localStorage.getItem('access_token');
  // OR from context / redux
  // const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return <DashboardLayout />;
};
const MainRoutes = {
  path: '/',
  element: <AuthGuard />,
  children: [
    {
      index: true,
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'default',
      element: <DashboardDefault />
    },
    {
      path: 'catalog/inventory',
      element: <SourceData />
    },
    {
      path: 'product-catalog',
      element: <ProductCatalog />
    },
    {
      path: 'product-catalog/:productId',
      element: <ProductCatalogDetail />
    },
    {
      path: 'listing',
      element: <ChannelListings />
    },
    {
      path: 'listing/:productId',
      element: <ListingDetail />
    },
    {
      path: 'inventory/:productId',
      element: <InventoryDetail />
    },
    {
      path: 'integration/sales-channels',
      element: <SalesChannels />
    },
    {
      path: 'integration/fullfillment-partners',
      element: <FullfilledPartners />
    },
    {
      path: 'orders',
      element: <Orders />
    },
    {
      path: 'orders/order-details/:orderId',
      element: <OrderDetails />
    },
    {
      path: 'pricing-rules',
      element: <PricingRules />
    },
    {
      path: 'users-management',
      element: <UserAndRoles />
    },
    {
      path: 'audit-logs',
      element: <AuditLogs />
    },
    {
      path: 'competitors',
      element: <Competitors />
    },
    {
      path: '/users-management',
      element: <UserAndRoles />
    },
    {
      path: 'settings',
      element: <Settings />
    },
    {
      path: 'profile',
      element: <Profile />
    }
  ]
};

export default MainRoutes;
